import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowRight, Globe, Warehouse } from "lucide-react";

const HERO = "/kentucky/life3.jpg";
const ease = [0.22, 1, 0.36, 1];

// CONCEPT 2 — "Cinematic Lifestyle": full-bleed campaign hero kept LIGHT & airy,
// slow Ken-Burns zoom, soft snow-white wash, floating glass info card, brand marquee.
export const Concept2 = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["0%", "14%"]);
  const marquee = ["KENTUCKY HORSEWEAR", "DY'ON", "VELARI", "GROOMING DELUXE", "KENTUCKY DOG"];

  return (
    <div className="bg-[#FFFAF4] text-[#08083a]">
      <section ref={ref} className="relative h-[88vh] min-h-[600px] overflow-hidden">
        <motion.img style={{ y: imgY, scale: 1.08 }} src={HERO} alt="Kentucky bridle detail"
          className="absolute inset-0 h-full w-full object-cover" />
        {/* light wash — keeps it airy, not dark */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#FFFAF4] via-[#FFFAF4]/55 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-[#FFFAF4]/90 to-transparent" />

        {/* floating glass card */}
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.5, ease }}
          className="absolute right-6 top-24 hidden w-64 rounded-2xl border border-[#08083a]/10 bg-white/70 p-5 backdrop-blur-md lg:block">
          <div className="flex items-center gap-2 text-[#FE7D01]"><Globe className="h-4 w-4" /><span className="text-xs font-semibold uppercase tracking-[0.16em]">Worldwide</span></div>
          <p className="mt-2 text-sm leading-snug text-[#08083a]/75">Express worldwide delivery, dispatched from our Ireland &amp; EU warehouses.</p>
          <div className="mt-3 flex items-center gap-2 border-t border-[#08083a]/10 pt-3 text-xs text-[#08083a]/60"><Warehouse className="h-3.5 w-3.5" /> In stock · IE &amp; EU</div>
        </motion.div>

        <div className="container-site relative flex h-full flex-col justify-end pb-16">
          <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease }}
            className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#FE7D01]">
            Official Kentucky Horsewear Reseller
          </motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.08, ease }}
            className="mt-4 max-w-3xl font-display text-5xl leading-[1.02] sm:text-7xl">
            Equip the extraordinary.
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.18, ease }}
            className="mt-5 max-w-xl text-[15px] leading-relaxed text-[#08083a]/75">
            The complete Kentucky collection — rugs, tack, grooming and rider apparel.
            Express worldwide shipping; free over €100 in Ireland.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, delay: 0.28, ease }}
            className="mt-8 flex flex-wrap gap-3">
            <a href="#" className="inline-flex items-center gap-2 rounded-full bg-[#FE7D01] px-7 py-3.5 text-sm font-semibold text-white shadow-[0_14px_30px_rgba(254,125,1,0.3)] transition-transform duration-200 hover:-translate-y-0.5">
              Explore the collection <ArrowRight className="h-4 w-4" />
            </a>
            <a href="#" className="inline-flex items-center gap-2 rounded-full border border-[#08083a]/20 bg-white/60 px-7 py-3.5 text-sm font-semibold backdrop-blur transition-colors hover:bg-white">
              Shop on Boomerang.ie
            </a>
          </motion.div>
        </div>
      </section>

      {/* brand marquee */}
      <div className="border-y border-[#08083a]/12 bg-[#08083a] py-4 text-white">
        <div className="flex gap-12 overflow-hidden">
          <motion.div className="flex shrink-0 gap-12 whitespace-nowrap"
            animate={{ x: ["0%", "-50%"] }} transition={{ duration: 22, repeat: Infinity, ease: "linear" }}>
            {[...marquee, ...marquee, ...marquee].map((m, i) => (
              <span key={i} className="flex items-center gap-12 font-display text-xl tracking-[0.08em] text-white/85">
                {m} <span className="h-1.5 w-1.5 rounded-full bg-[#FE7D01]" />
              </span>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};
